function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 28.1H77.8l26.5 28.4H241v120.6l28.3 28.5zM219.2 176.6l-20.1 20.1 16 15.9h-144v-130l15.7 15.7 20-20-50.1-50.2L6.5 78.3l20.1 20 16.1-16.1V241h172.4l-16 15.9 20.1 20 50.1-50.1z"
})));